import { LoaderSvg } from '../../assets/svgs';
import { LoaderWrapper } from './loader.style';

const LoaderComponent = () => {
    return (
        <LoaderWrapper>
            {/* <LoaderSpin /> */}
            <LoaderSvg />
        </LoaderWrapper>
    );
};

export default LoaderComponent;
